import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdatePrimaryPaymentMethodMutationVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  id: Types.Scalars['bigint']['input'];
}>;


export type UpdatePrimaryPaymentMethodMutation = { __typename?: 'mutation_root', setFalse?: { __typename?: 'arpaymentmethods_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'arpaymentmethods', id: number, customer_id: number }> } | null, setTrue?: { __typename?: 'arpaymentmethods_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'arpaymentmethods', id: number, customer_id: number }> } | null };


export const UpdatePrimaryPaymentMethodDocument = gql`
    mutation updatePrimaryPaymentMethod($customerId: bigint!, $id: bigint!) {
  setFalse: update_arpaymentmethods(
    where: {customer_id: {_eq: $customerId}}
    _set: {primary: false}
  ) {
    affected_rows
    returning {
      id
      customer_id
    }
  }
  setTrue: update_arpaymentmethods(where: {id: {_eq: $id}}, _set: {primary: true}) {
    affected_rows
    returning {
      id
      customer_id
    }
  }
}
    `;
export type UpdatePrimaryPaymentMethodMutationFn = Apollo.MutationFunction<UpdatePrimaryPaymentMethodMutation, UpdatePrimaryPaymentMethodMutationVariables>;

/**
 * __useUpdatePrimaryPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePrimaryPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrimaryPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrimaryPaymentMethodMutation, { data, loading, error }] = useUpdatePrimaryPaymentMethodMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatePrimaryPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrimaryPaymentMethodMutation, UpdatePrimaryPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrimaryPaymentMethodMutation, UpdatePrimaryPaymentMethodMutationVariables>(UpdatePrimaryPaymentMethodDocument, options);
      }
export type UpdatePrimaryPaymentMethodMutationHookResult = ReturnType<typeof useUpdatePrimaryPaymentMethodMutation>;
export type UpdatePrimaryPaymentMethodMutationResult = Apollo.MutationResult<UpdatePrimaryPaymentMethodMutation>;
export type UpdatePrimaryPaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePrimaryPaymentMethodMutation, UpdatePrimaryPaymentMethodMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (setFalse, setTrue): returns the full response object.
 * @source {@link src/features/billing/queries/updatePrimaryPaymentMethod.mutation.gql}
 */
export async function updatePrimaryPaymentMethod(
  variables: UpdatePrimaryPaymentMethodMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<UpdatePrimaryPaymentMethodMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<UpdatePrimaryPaymentMethodMutation>(
    UpdatePrimaryPaymentMethodDocument,
    variables,
    requestOptions
  )
}